import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reminder-email-logs-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Reminder Email Logs</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <app-reminder-email-logs
        [showFilters]="true"
        [autoLoad]="true"
        [perPage]="10"
        (dataLoaded)="modal.close($event)"
        (error)="modal.dismiss($event)">
      </app-reminder-email-logs>
    </div>
  `,
  styles: [`
    .modal-body {
      padding: 1rem;
      max-height: 80vh;
      overflow-y: auto;
    }
  `]
})
export class ReminderEmailLogsModalComponent {
  constructor(public modal: NgbActiveModal) {}
} 